import { styled } from '@mui/material/styles';

import { COLORS } from '../../IndividualPlan/tokens';

export interface DataNotesProps {
  notes?: string[] | null;
}

const NotesBlock = styled('aside')({
  marginTop: 20,
  padding: '0 24px',
  color: COLORS.muted,
  fontSize: 13,
  lineHeight: '18px',
  '& .data-notes-title': {
    margin: 0,
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  '& .data-notes-list': {
    margin: '4px 0 0',
    paddingLeft: 18,
  },
  '& .data-notes-list li': {
    marginTop: 2,
  },
});

export function DataNotes({ notes }: DataNotesProps) {
  const items = (notes ?? []).filter((note) => note.trim() !== '');
  if (items.length === 0) {
    return null;
  }

  return (
    <NotesBlock data-testid="data-notes" aria-label="Data notes">
      <p className="data-notes-title">Data Notes</p>
      <ul className="data-notes-list">
        {items.map((note) => (
          <li key={note}>{note}</li>
        ))}
      </ul>
    </NotesBlock>
  );
}
